import CompleteSendEmailForgotPassword from '.';

export default function CastCompleteSendEmailForgotPassword() {
  return <CompleteSendEmailForgotPassword changePassword={false} />;
}
